import { Component, Inject, OnInit, TemplateRef, ViewChild, Output, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Observable } from 'rxjs/Rx';
import { MacroService } from './shared/services/macro.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  @ViewChild('template')
  private msgTempRef: TemplateRef<any>;
  modalRef: BsModalRef;

  @ViewChild('visualInforme')
  private visualInformeModal: TemplateRef<any>;
  modalVisualInformeModal: BsModalRef;

  constructor(
    private modalService: BsModalService,
    @Inject(MacroService) public macroService: MacroService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService, private router: Router) {
  }

  idmaActivo = false;
  usuario;
  idUsuarioLog;
  alertasC = 0;
  alertasU;
  crud = false;
  perfiles;
  consulataAlertas = false;
  consultaInforme = false;
  informe = {
    'idempresa': 0,
    'notificacion': '',
    'fechaActualizacion': 0
  };
  ID_EMPRESA;
  fechaInforme;
  notificacionesLeidas = [];
  notificacionesNoLeidas = [];
  logo = null;
  logoInactive = true;

  private menuItemsArray: any[] = [
    { 'title': '🚪 Cerrar sesión', 'link': 'session/terminar' }
  ];

  config = {
    animation: "squeeze",
    offset: { top: 72 },
    closeOnCLick: true
  };

  ngOnInit() {
    this.idmaActivo = this.storage.get('idma') !== null;
    this.ID_EMPRESA = this.storage.get('idem');
    this.idUsuarioLog = this.storage.get("nmus");
    this.alertasC = Number(this.storage.get("alertasC"));
    this.verificacionUsuario();
    this.verificarToken();
    Observable.interval(1000).subscribe(x => {
      this.perfiles = this.storage.get("nmper");
      this.idmaActivo = this.storage.get('idma') !== null;
      //this.usuarioinvitado = this.storage.get("uinvi");
      this.consultarUsuario();
      this.crud = this.perfiles !== null && this.perfiles !== undefined && this.perfiles.indexOf('crud') > -1;
      //this.insertarMenuCrud();
    });

    Observable.interval(60000).subscribe(x => {
      this.verificarToken();
    });

    Observable.interval(2000).subscribe(x => {
      if (!this.crud && this.ID_EMPRESA) {
				this.consultarAlertasPorCliente(this.storage.get('idem'));
      }
    });

    Observable.interval(420000000).subscribe(x => {
      var bConfirm = confirm('Favor confirmar si deseacontinuar con la session.');
      if (bConfirm) {
        return;
      } else {
        const token = this.storage.get('idma');
        this.macroService.cerrarSession(token).subscribe(
          () => {
            this.storage.set('idma', null);
            this.usuario = null;
            this.storage.set('reload', '1');
            this.router.navigate(['session/iniciar']);
          });
      }
    });

    this.verificarInformeProveedor();

    if (!this.idmaActivo || this.idmaActivo === undefined || this.idmaActivo === null) {
      this.router.navigate(['session/iniciar']);
      return;
    }

  }

  ngAfterViewChecked() {
    if (this.ID_EMPRESA !== null && this.logo === null && this.logoInactive) {
      this.macroService.consultarEmpresa(this.ID_EMPRESA).subscribe(response =>{
        if (response.logo !== undefined && response.logo !== null && response.logo !== ''){
          this.logo = response.logo
          this.logoInactive = false;
        } else {
          this.logo = '../assets/imagenes/user.png';
          this.logoInactive = false;
        }
      });
    }
  }

  private verificarToken() {
    if (this.idmaActivo) {
      this.macroService.verificarToken().subscribe(data => {
        if (!data) {
          this.storage.set('idma', null);
          this.storage.set('reload', '1');
          this.router.navigate(['session/iniciar']);
        }
      }, err => {
        console.error(err);
      });
    }
  }

  private verificacionUsuario() {
    this.idmaActivo = this.storage.get('idma') !== null;
    Observable.interval(60000).subscribe(x => {
      this.idmaActivo = this.storage.get('idma') !== null;
      this.macroService.status().subscribe(data => { }, err => {
        if("11" !== (this.storage.get('idem')) || "10" !== (this.storage.get('idem')) ){
          const token = this.storage.get('idma');
          this.macroService.cerrarSession(token).subscribe(() => {            
            this.storage.set('idma', null);
            this.usuario = null;
            this.storage.set('reload', '1');
            this.router.navigate(['session/iniciar']);
          });
        }
      });
      if ((this.usuario === null || this.usuario === undefined)) {
        this.verificarToken();
      }
    });
  }

  public onMenuClose() {
  }

  public onMenuOpen() {
  }

  private onItemSelect(item: any) {
    this.router.navigateByUrl(item.link);
  }

  public consultarUsuario() {
    if (this.idmaActivo && (this.usuario === null || this.usuario === undefined)) {
      this.macroService.consultarUsuario(this.storage.get('nmus')).subscribe(
        data => {
          this.usuario = data;
          this.perfiles = this.storage.get("nmper");
          this.crud = this.perfiles.indexOf('crud') > -1;
          this.ID_EMPRESA = this.usuario.idempresa;
          this.verificarInformeProveedor();
        });
    }
  }

  consultarAlertasPorCliente(idCliente: number) {
    let validacionSegmentoAlerta = this.validarSegmentoAlerta();
    if (validacionSegmentoAlerta) {
			if (idCliente !== undefined && idCliente !== null && idCliente !== 0) {
				this.macroService.alertasPorCliente(idCliente).subscribe(
					data => {
						let d = data.filter(not => not.estado.toLowerCase() === ('no leido'));
						let r = data.filter(not => not.estado.toLowerCase() === ('recibida'));
						if (d.length > this.alertasC && this.modalRef === undefined) {
							this.alertasC = d.length;
							for(var i=0; i< d.length ; i++) {
								let not = d[i];
								not.estado = 'recibida';
								this.macroService.alertasActualizar(not).subscribe(() => {
								}, () => {
								});
							}
							this.consulataAlertas = true;
							this.consultaInforme = false;
							this.modalRef = this.modalService.show(this.msgTempRef);
							if (this.router.url === '/empresa/alertas') {
									setTimeout('location.reload();', 30000);
							} else {
								this.informe.idempresa=this.ID_EMPRESA;
								this.informe.notificacion = "<center style=\"align:center;\"><h1 >Importante</h1>"+
								"<p>Tienes Alertas generadas que estan en estado recibido o no leido que debe verificar.</p>"+
								"</center>";
								this.informe.fechaActualizacion = d[0].fechaNotificacion
								this.modalVisualInformeModal = this.modalService.show(this.visualInformeModal);
							}
							this.alertasC = d.length + r.length;
							this.storage.set("alertasC", (d.length + r.length))
						} else {
							this.alertasC = r.length;
							this.storage.set("alertasC", r.length)
						}
					}, err => {
						console.error(err);
					}
				);
			}
    }
  }

  validarSegmentoAlerta(): boolean {
    const nsgusr = this.storage.get('nsgusr');
		let have_alerts = 0;
    for(let x of nsgusr) {
				if (x) {
					const seg = x.split('-');
					for(let y of seg) {
						if (y === 'Alertas Empresa' || y === 'Alertas') {
							have_alerts += 1;
						}
					}
				}
    }
    return have_alerts > 0;
  }

  consultarAlertasPorUsuario(idUsuario: number) {
    if (idUsuario !== undefined && idUsuario !== null) {
      this.macroService.alertasPorUsuario(idUsuario).subscribe(
        data => {
          var d = data.filter(not => not.estado.toLowerCase() === ('no leido'));
          if (d.length > this.alertasU && this.modalRef === undefined) {
            this.modalRef = this.modalService.show(this.msgTempRef);
          }
          this.alertasU = d.length;
        }, err => {
          console.error(err);
        }
      );
    }
  }

  addValidateItemCrud(newItem, itemMenu) {
    const filter = itemMenu.subItems.filter(element => element.title === newItem.title);
    if (filter.length === 0) {
      itemMenu.subItems.push(newItem);
    }
  }

  verificarInformeProveedor() {
    if (this.idmaActivo) {
      this.macroService.consultarNotificaionesProveedorLeidos(this.ID_EMPRESA).subscribe(
        response => {
          this.notificacionesLeidas = response;
        }, error => {}
      );
      this.macroService.consultarNotificaionesProveedorNoLeidos(this.ID_EMPRESA).subscribe(
        response => {
          this.notificacionesNoLeidas = response;
        }, error => {}
      );
    }
  }

  openModalNotificarProveedor(notify) {
    notify.notificacion = notify.notificacion.replace('www.macrosistemasapp.com/', '');
    notify.notificacion = notify.notificacion.replace('macrosistemasapp.com/', '');
    this.informe = notify;
    this.modalVisualInformeModal = this.modalService.show(this.visualInformeModal);
    if (!notify.estado) {
      this.macroService.actualizarInformarProveedor(notify, notify.idinforme).subscribe(
        response => {
          this.verificarInformeProveedor();
        }, error => {}
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts